/* tslint:disable */

declare var Object: any;
export interface TschatserviceInterface {
  "id"?: number;
}

export class Tschatservice implements TschatserviceInterface {
  "id": number;
  constructor(data?: TschatserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tschatservice`.
   */
  public static getModelName() {
    return "Tschatservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tschatservice for dynamic purposes.
  **/
  public static factory(data: TschatserviceInterface): Tschatservice{
    return new Tschatservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tschatservice',
      plural: 'Tschatservices',
      path: 'Tschatservices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tschatservice.ts